module.exports = __webpack_public_path__ + "careers_page_minimal_design_webdesign_simple_clean_digitalfactory.jpg?5c5aee06ce5c5a00916e00418d025e09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/careers_page_minimal_design_webdesign_simple_clean_digitalfactory.jpg
// module id = 46
// module chunks = 0